import React, { useState } from "react"
import FooterThree from "../../common/Footer/FooterThree";
import Menu from "../../common/Menu/Menu";
import ContactInfo from "./ContactInfo";
import ContactUsBanner from "./ContactUsBanner";
import ElevatorLoader from "../../Loder/ElevatorLoader";

const ContactUs = () => {
  const [loading, setLoading] = useState(true);
  return (
    <div>
      {loading && <ElevatorLoader onFinish={() => setLoading(false)} />}
      <Menu header_style_2={true} />
      <ContactUsBanner />
      <ContactInfo />
      <FooterThree />
    </div>
  );
};

export default ContactUs;
